import styled from "styled-components";
import { ReactComponent as LockIcon } from "../../assets/icons/drawer/lock.svg";
import { ReactComponent as VisibilityOff } from "../../assets/icons/visibility_off.svg";
import { ReactComponent as Visibility } from "../../assets/icons/visibility.svg";
import { ReactComponent as MailIcon } from "../../assets/icons/drawer/mail.svg";
import { NavLink } from "react-router-dom";

export const Title = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 4rem;
  margin-bottom: 3rem;
`;
export const Subtitle = styled.span`
  color: #454584;
  font-family: "Avenir-Medium";
  font-size: 2.8rem;
  font-weight: "500";
  letter-spacing: -0.178px;
  margin-top: 2rem;
`;

export const Error = styled.div`
  color: #dc143c;
  font-size: 13px;
  bottom: -50px;
  display: inline-block;
  position: absolute;
`;
export const MainContainer = styled.div`
  flex-direction: column;
  background: #f6f6f9;
  align-items: center;
  gap: 150px;
  min-height: 100vh;
  display: flex;
`;
export const HeaderWrapper = styled.div`
  background: #484888;
  width: 100%;
  position: fixed;
  z-index: 500;
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin-top: 3rem;

  @media (max-width: 450px) {
    gap: 1rem;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
`;
export const CloseContainer = styled.div`
  border-radius: 1rem;
  background: #484888;
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  width: 5.5rem;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -1rem;
  left: -1rem;
  @media (max-width: 870px) {
    top: 1rem;
    right: 1rem;
    left: unset;
    width: 4.5rem;
    height: 4.5rem;
  }
`;
export const ScreenContent = styled.div`
  z-index: 1;
  position: relative;
`;

export const Input = styled.input`
  border: ${(props) =>
    props.$error ? "1px solid #FF9494" : "1px solid #8c8c8c"};
  border-radius: 15px;
  height: 60px;
  user-select: none;
  background: none;
  width: 100%;
  font-weight: 700;
  transition: 0.2s;
  color: rgba(69, 69, 132, 1);

  &:active,
  &:hover,
  &:focus {
    box-shadow: none;
    color: #000;
    &::placeholder {
      color: #000;
    }
  }

  &::placeholder {
    color: rgba(69, 69, 132, 1);
  }

  padding: ${(props) =>
    props.$ar ? "15px 38px 15px 15px" : "15px 15px 15px 38px"};

  font-family: "Avenir";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.178px;

  @media (max-width: 450px) {
    font-size: 14px;
    border-radius: 7.5px;
    height: 30px;
  }
`;

export const SubmitButton = styled.button`
  font-family: "FrankfurterEF-Medium";

  letter-spacing: -0.178px;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  user-select: none;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: white;
  background: linear-gradient(180deg, #7f7fac 0%, #484888 100%), #ffffff;
  box-shadow: 0px 12px 24px -6px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 0px 35px;
  border: none;
  width: 100%;
  height: 70px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  &:hover {
    background: ${({ disabled }) => (disabled ? null : "#484888")};
  }

  &:active {
    ${({ disabled }) =>
      disabled
        ? null
        : `
    box-shadow: 0px 2px 8px -5px rgb(128, 128, 128);
    transition: all 0.1s ease-in;
    transform: scale(0.95);
  `};
  }
  @media (max-width: 450px) {
    font-size: 16px;
    border-radius: 7.5px;
    height: 45px;
  }
`;
export const StyledText = styled.span`
  color: rgba(255, 0, 0, 0.75);
  font-family: "Avenir-Medium";
  font-size: 16px;
  letter-spacing: -0.178px;
`;
export const ButtonContainer = styled.div`
  display: flex;
  user-select: none;
  width: 100%;
  position: absolute;
  padding: 2rem;
  bottom: 0;
  right: 0;
  left: 0;
`;
export const ForgotPwContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: -1rem;
`;
export const ForgotPw = styled.span`
  color: #454584;
  font-family: "Avenir-Medium";
  font-size: 1.6rem;
  font-weight: "400";
  cursor: pointer;
  letter-spacing: -0.178px;
`;

export const TextDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;
export const StyledTextDiv = styled(TextDiv)`
  justify-content: center;
  width: 100%;

  margin-top: 15px;
  gap: 5px;
`;

export const CreateText = styled.span`
  color: #484888;
  opacity: 0.7;
  font-family: "Avenir";
  user-select: none;
  font-size: 16px;
  @media (max-width: 450px) {
    font-size: 14px;
  }
`;

export const TabTitle = styled.span`
  font-family: "Avenir-Heavy";
  font-size: 14px;
  letter-spacing: -0.41px;
`;

export const TabContainer = styled.div`
  padding: 0px 20px 8px 20px;
  user-select: none;
  border-radius: 2px;
  cursor: pointer;
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 25px;
  justify-content: center;
`;

export const ContentContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 20px;
  border: 1;
`;

export const StyledMailIcon = styled(MailIcon)`
  width: 24px;
  height: 24px;
  right: ${(props) => (props.$ar ? "10px" : "unset")};
  left: ${(props) => (props.$ar ? "unset" : "10px")};
  top: 17.5px;
  @media (max-width: 450px) {
    top: 4.5px;
  }
`;

export const StyledLockIcon = styled(LockIcon)`
  width: 24px;
  height: 24px;

  right: ${(props) => (props.$ar ? "10px" : "unset")};
  left: ${(props) => (props.$ar ? "unset" : "10px")};
  top: 17.5px;
  @media (max-width: 450px) {
    top: 4.5px;
  }
`;

export const StyledVisibilityOff = styled(VisibilityOff)`
  width: 24px;
  height: 24px;
  top: 17.5px;
  position: absolute;
  right: ${(props) => (props.$ar ? "unset" : "20px")};
  left: ${(props) => (props.$ar ? "20px" : "unset")};
  @media (max-width: 450px) {
    top: 4.5px;
  }
`;

export const StyledVisibility = styled(Visibility)`
  width: 24px;
  height: 24px;
  top: 17.5px;
  position: absolute;
  right: ${(props) => (props.$ar ? "unset" : "20px")};
  left: ${(props) => (props.$ar ? "20px" : "unset")};
  @media (max-width: 450px) {
    top: 4.5px;
  }
`;
export const OuterContainer = styled.div`
  justify-content: space-between;
  display: flex;
  margin-top: 180px;
  flex-direction: column;
  background-color: #fff;
  min-height: 520px;
  padding: 30px 0px 60px 0px;
  border: 1px solid #b1b1b1;
  width: 548px;
  -webkit-box-shadow: 0px 0px 15px 5px rgba(1, 1, 1, 0.05);
  -moz-box-shadow: 0px 0px 15px 5px rgba(1, 1, 1, 0.05);
  box-shadow: 0px 4px 4px 0px rgba(1, 0, 1, 0.1);
  border-radius: 30px;

  @media (max-width: 560px) {
    width: 400px;
  }
  @media (max-width: 450px) {
    min-height: 444px;
    width: 90%;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 3rem;
  height: 100%;
  max-height: 50rem;

  @media (max-height: 700px) {
    max-height: 50rem;
  }
`;

export const Link = styled(NavLink)`
  user-select: none;
  display: flex;
  align-items: center;
  flex-direction: row;

  opacity: 0.6;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
  gap: 1rem;
  padding: 0.25rem 0rem;
  width: 100%;

  color: ${(props) => (props.$logout ? "#c66b66" : "#484888")};

  font-family: "Avenir-Medium";
  font-size: 1.8rem;
  font-weight: "500";
  letter-spacing: -0.178px;

  &.active {
    opacity: 1;
  }

  &:hover {
    padding: 0.25rem 1rem;
    opacity: 1;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -0.5rem;
  align-items: center;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
